module.exports = __webpack_public_path__ + "img/UHF-LS-50_in_pipe.725cc4ae.webp";